import React from 'react';
import { ShoppingCart, Shield, Truck, CreditCard, ExternalLink } from 'lucide-react';
import SEO from '../components/SEO';

const WhereToBuy = () => {
  return (
    <div className="dark-container pt-20">
      <SEO title="Dove Acquistare - ALLMX" description="Acquista ricambi e accessori motocross su ALLMX.it. Spedizione veloce, pagamenti sicuri, oltre 700 prodotti." url="https://allmx.it/where-to-buy" />
      <section className="py-20 px-6 lg:px-[7.6923%]" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="max-w-[1400px] mx-auto text-center">
          <h1 className="display-large mb-4">Where to Buy</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Shop ALLMX products on trusted marketplaces
          </p>
        </div>
      </section>

      {/* Main Store Cards */}
      <section className="py-20 px-6 lg:px-[7.6923%]">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Amazon Store */}
            <div className="dark-card p-12 text-center">
              <div className="mb-8">
                <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <ShoppingCart size={40} style={{ color: 'var(--brand-primary)' }} />
                </div>
                <h2 className="display-medium mb-4">Amazon Store</h2>
                <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
                  Browse our complete collection on Amazon Italy with Prime shipping and trusted buyer protection.
                </p>
              </div>
              
              <div className="space-y-4 mb-8 text-left">
                <div className="flex items-start gap-3">
                  <Shield size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">Buyer Protection</div>
                    <div className="body-medium">Amazon A-to-Z Guarantee on all purchases</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Truck size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">Fast Shipping</div>
                    <div className="body-medium">Prime delivery available across Italy</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CreditCard size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">Secure Payment</div>
                    <div className="body-medium">Multiple payment options, all secure</div>
                  </div>
                </div>
              </div>

              <a
                href="https://www.amazon.it/s?me=A3526ZZLQNVU1W&marketplaceID=APJ6JRA9NG5V4"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary w-full"
              >
                Visit Amazon Store <ExternalLink size={20} />
              </a>
            </div>

            {/* eBay Store */}
            <div className="dark-card p-12 text-center">
              <div className="mb-8">
                <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <ShoppingCart size={40} style={{ color: 'var(--brand-primary)' }} />
                </div>
                <h2 className="display-medium mb-4">eBay Store</h2>
                <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
                  Shop directly from our eBay Italy store with competitive prices and reliable shipping.
                </p>
              </div>
              
              <div className="space-y-4 mb-8 text-left">
                <div className="flex items-start gap-3">
                  <Shield size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">eBay Money Back</div>
                    <div className="body-medium">Full refund if item not as described</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Truck size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">Reliable Shipping</div>
                    <div className="body-medium">Tracked shipping across Europe</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CreditCard size={20} style={{ color: 'var(--brand-primary)' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold mb-1">PayPal Protection</div>
                    <div className="body-medium">Safe transactions with PayPal</div>
                  </div>
                </div>
              </div>

              <a
                href="https://www.ebay.it/str/allmx"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary w-full"
              >
                Visit eBay Store <ExternalLink size={20} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Shop With Us */}
      <section className="py-20 px-6 lg:px-[7.6923%]" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="display-medium mb-12">Why Shop Through Marketplaces?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
            <div className="dark-card p-6">
              <h3 className="text-xl font-semibold mb-3">Trust & Security</h3>
              <p className="body-medium">
                Both Amazon and eBay provide comprehensive buyer protection policies, 
                ensuring your purchase is safe and secure.
              </p>
            </div>
            <div className="dark-card p-6">
              <h3 className="text-xl font-semibold mb-3">Easy Returns</h3>
              <p className="body-medium">
                Not satisfied? Return policies make it simple to get a refund or 
                exchange through established marketplace processes.
              </p>
            </div>
            <div className="dark-card p-6">
              <h3 className="text-xl font-semibold mb-3">Fast Delivery</h3>
              <p className="body-medium">
                Benefit from the efficient logistics networks of major marketplaces 
                for quick delivery to your door.
              </p>
            </div>
            <div className="dark-card p-6">
              <h3 className="text-xl font-semibold mb-3">Customer Reviews</h3>
              <p className="body-medium">
                Read authentic reviews from other customers to make informed 
                decisions about your purchase.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 lg:px-[7.6923%]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="display-large mb-6">Ready to Shop?</h2>
          <p className="body-large mb-10" style={{ color: 'var(--text-secondary)' }}>
            Choose your preferred marketplace and start browsing our premium products
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.amazon.it/s?me=A3526ZZLQNVU1W&marketplaceID=APJ6JRA9NG5V4"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Shop on Amazon
            </a>
            <a
              href="https://www.ebay.it/str/allmx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              Shop on eBay
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhereToBuy;
